<template>
  <div :class="wrpCls">
    <a-space size="middle">
      <!-- 当前项目选择 -->
      <span v-if="showProjectSelect" style="margin-right: 8px">当前项目：</span>
      <a-select
        v-if="showProjectSelect"
        v-model:value="currentProjectId"
        show-search
        :filter-option="filterProjectOption"
        placeholder="请选择项目"
        style="width: 150px"
        allow-clear
        @change="handleProjectChange"
        class="project-select"
      >
        <a-select-option
          v-for="(project, index) in projectList"
          :key="project.id || index"
          :value="project.id"
        >
          {{ project.chineseName || project.projectCode || `项目${index + 1}` }}
        </a-select-option>
      </a-select>
      <!--      <a-tooltip placement="bottom">
              <template slot="title">
                源码地址
              </template>
              <a-icon type="github" @click="toGithub" :style="{ fontSize: '20px' }"/>
            </a-tooltip>
            <a-tooltip placement="bottom">
              <template slot="title">
                文档地址
              </template>
              <a-icon type="question-circle-o" @click="toDoc" :style="{ fontSize: '20px' }"/>
            </a-tooltip>-->
      <screenfull />
      <!--      <notice-icon v-hasPermi="['system:notice:list']" style="cursor: pointer;"/>-->
      <avatar-dropdown
        :menu="showMenu"
        :current-user="currentUser"
        :class="prefixCls"
      />
      <!-- 暂只支持中文，国际化可自行扩展 -->
      <!-- <select-lang :class="prefixCls" /> -->
    </a-space>
  </div>
</template>

<script>
import { $on, $off, $once, $emit } from '../../utils/gogocodeTransfer'
import AvatarDropdown from './AvatarDropdown'
import NoticeIcon from '@/components/NoticeIcon'
import Screenfull from '@/components/Screenfull'
import SelectLang from '@/components/SelectLang'
import { getInfo } from '@/api/login'
import storage from 'store'

export default {
  name: 'RightContent',
  components: {
    AvatarDropdown,
    NoticeIcon,
    Screenfull,
    SelectLang,
  },
  props: {
    prefixCls: {
      type: String,
      default: 'ant-pro-global-header-index-action',
    },
    isMobile: {
      type: Boolean,
      default: () => false,
    },
    topMenu: {
      type: Boolean,
      required: true,
    },
    theme: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      showMenu: true,
      currentUser: {},
      docUrl: process.env.VUE_APP_BASE_API + '/doc',
      githubUrl: 'http://gitlab.niurenjianzhan.com/zhangxun/java-framework',
      projectList: [],
    }
  },
  computed: {
    wrpCls() {
      return {
        'ant-pro-global-header-index-right': true,
        [`ant-pro-global-header-index-${
          this.isMobile || !this.topMenu ? 'light' : this.theme
        }`]: true,
      }
    },
    showProjectSelect() {
      // 如果没有项目数据，不显示
      if (!this.projectList || this.projectList.length === 0) {
        return false
      }
      // 检查当前路由是否在允许列表中
      const matched = this.$route ? this.$route.matched || [] : []
      const titles = matched
        .map((item) => item && item.meta && item.meta.title)
        .filter(Boolean)
      const allowList = [
        '项目管理',
        '项目员工',
        '人员轨迹',
        '空间管理',
        '信标管理',
        '手环管理',
        '设备管理',
        '投诉工单',
        '项目排班',
        '空间服务时长统计',
        '员工作业统计',
      ]
      const isAllowed = titles.some((title) => allowList.includes(title))
      return isAllowed
    },
    currentProjectId: {
      get() {
        return this.$store.getters.currentProjectId
      },
      set(value) {
        this.handleProjectChange(value)
      },
    },
  },
  watch: {
    // 监听路由变化，确保计算属性能正确更新
    $route() {
      this.$forceUpdate()
    },
    // 监听项目列表变化
    projectList: {
      handler(newVal) {
        // 项目列表更新
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {
    setTimeout(() => {
      this.currentUser = {
        name: 'RuoYi',
      }
    }, 1500)
    this.loadUserInfo()
  },
  methods: {
    toDoc() {
      window.open(this.docUrl)
    },
    toGithub() {
      window.open(this.githubUrl)
    },
    /** 加载用户信息并获取项目列表 */
    loadUserInfo() {
      getInfo()
        .then((res) => {
          if (res.success && res.data) {
            // 从用户信息中获取项目列表
            const projectInfoList = res.data.projectInfoList || []
            this.projectList = Array.isArray(projectInfoList)
              ? projectInfoList
              : []

            // 从 Vuex 获取当前项目ID
            let savedProjectId = this.$store.getters.currentProjectId

            // 如果 Vuex 中没有，尝试从本地存储获取
            if (!savedProjectId) {
              savedProjectId = storage.get('currentProjectId')
            }

            const matchedProject = savedProjectId
              ? this.projectList.find((p) => p.id == savedProjectId)
              : null

            if (matchedProject) {
              this.$store.commit('SET_CURRENT_PROJECT_ID', matchedProject.id)
              storage.set('currentProjectId', matchedProject.id)
              // 刷新后从本地恢复项目时也要通知列表页，否则信标等页会按空 projectId 查出其他项目
              $emit(this.$root, 'project-changed', matchedProject.id)
            } else if (this.projectList.length > 0) {
              // 无已保存项目时，默认选中第一个项目（与项目看板一致）
              const defaultProjectId = this.projectList[0].id
              this.$store.commit('SET_CURRENT_PROJECT_ID', defaultProjectId)
              storage.set('currentProjectId', defaultProjectId)
              $emit(this.$root, 'project-changed', defaultProjectId)
            }
          } else {
            this.projectList = []
          }
        })
        .catch((error) => {
          this.projectList = []
        })
    },
    /** 过滤项目选项 */
    filterProjectOption(input, option) {
      if (!input) return true
      const value = option.componentOptions.propsData.value
      const project = this.projectList.find((p) => p.id === value)
      if (project) {
        const searchText = input.toLowerCase()
        const chineseName = (project.chineseName || '').toLowerCase()
        const projectCode = (project.projectCode || '').toLowerCase()
        return (
          chineseName.indexOf(searchText) >= 0 ||
          projectCode.indexOf(searchText) >= 0
        )
      }
      return false
    },
    /** 处理项目选择变化 */
    handleProjectChange(value) {
      const projectId = value || undefined
      // 存储到 Vuex
      this.$store.commit('SET_CURRENT_PROJECT_ID', projectId)

      if (projectId) {
        // 同时保存到本地存储
        storage.set('currentProjectId', projectId)
      } else {
        storage.remove('currentProjectId')
      }
      // 无论是否选择项目，都通知其他组件刷新
      $emit(this.$root, 'project-changed', projectId)
    },
  },
  emits: ['project-changed'],
}
</script>

<style scoped>
.project-select :deep(.ant-select-selector) {
  background: #FFFFFF !important;
  border-radius: 4px 4px 4px 4px !important;
  border: 1px solid #C7C7C7 !important;
}
</style>
